import React, { useState, useContext, useEffect } from "react";
import uuid from "react-native-uuid";
import ReactDOM from "react-dom";
import AddCommand from "../../Commands/AddCommand/AddCommand";
import CloseCommand from "../../Commands/CloseCommand/CloseCommand";
import SaveCommand from "../../Commands/SaveCommand/SaveCommand";
import DiscardCommand from "../../Commands/DiscardCommand/DiscardCommand";
import { store } from "../../../store.js";
import useValidationInput from "../../../Hooks/useValidationInput.js";
import useAxiosOperation from "../../../Hooks/useAxiosOperation.js";
import TreeViewDialog from "../../TreeViewDialog/TreeViewDialog";
import SpinnerIcon from "../../Commands/SpinnerIcon/SpinnerIcon.js";
import EditableDropDownList from "../../EditableDropDownList/EditableDropDownList";
import MiddleEditCommand from "../../Commands/MiddleEditCommand/MiddleEditCommand";
import ShowCommand from "../../Commands/ShowCommand/ShowCommand";
import HideCommand from "../../Commands/HideCommand/HideCommand";
import DropDownListNew from "../../DropDownList/DropDownListNew";
import CheckBox from "../../Commands/CheckBox/CheckBox";
import SimpleDialog from "../../SimpleDialog/SimpleDialog";
import CustomLoading from "../../SimpleModal/CustomLoading";
import "./Information.css";
import CustomAlert from "../../SimpleModal/CustomAlert";
import SimpleModal from "../../SimpleModal/SimpleModal";
import useModal from "../../../Hooks/useModal";
import RichTextEditor from "../../Commands/RichTextEditor/RichTextEditor";
import FormSettings from "../FormSettings/FormSettings";
import { useLocation } from "react-router-dom";
import useGetValueFromArray from "../../../Hooks/useGetValueFromArray.js";


export default function SettingsStep (props)  {
  var _ = require("lodash")
  const globalState = useContext(store);
  const { dispatch } = globalState;
  
  const axiosOperation = useAxiosOperation(true);
  const { isShowing, toggle } = useModal();
  const getValueFromArray = useGetValueFromArray();
  const actions = { 
     events : {
      type: {onLoad:"onLoad", onkeyPress:"onkeyPress", onChange:"onChange", onMouseOver: "onMouseOver", onMouseLeave:"onMouseLeave", onBlur: "onBlur", onMouseDown: "onMouseDown", onClick: "onClick", onMouseEnter: "onMouseEnter"},
      lists:[{id:1, item:"onLoad"},{id:2, item:"onChange"},{id:3, item:"onClick"},{id:4, item:"onMouseOver"},{id:5, item:"onMouseLeave"},{id:6, item:"onBlur"},{id:8, item:"onMouseEnter"}]
    },
    replacesValues: {field:"$field", title:"$title"},
    option : {event: "Event", decision: "Decision", task: "Task"},
    event : {email:"Email", api:"Api",type: {key:"key", value:"value"}},
    decision : {preConditions:"PreConditions", postConditions:"PostConditions",type: {key:"key", value:"value"}},
    task : {form:"Form", policy:"Policy", alert:"Alert", new:"New", inProgress:"In progress", resolved:"Resolved", done:"Done", type: {key:"key", value:"value"}}
  }

  const currentSetting = {
          options : ["Task", "Event","Decision"],
          event:{ options : ["Email", "Api"]},
          decision:{ options : ["PreConditions", "PostConditions"]},
          task:{ options : ["Alert", "Form", "Policy"], alert:{ options : ["New", "Approved", "In Progress", "Resolved", "Done"] }},
          replacesValues : [{old: "$title", new: ""},{old: "$field", new: ""}]
      }

  const menu = {
    operation : {Add:"ADD", Update:"UPDATE", Delete:"DELETE", Select:"SELECT", Settings:"SETTINGS"},
    firstOperand :{ 
      validations : { onBlur: [{ type:"REQUIRE"}]},
      replacesValues : [{old: "$title", new: "firstOperand"},{old: "$field", new: "firstOperand"}] },
    secondOperand :{ 
      validations : { onBlur: [{ type:"REQUIRE"}]},
      replacesValues : [{old: "$title", new: "secondOperand"},{old: "$field", new: "secondOperand"}] },
    key :{ 
      validations : { onBlur: [{ type:"REQUIRE"}]},
      replacesValues : [{old: "$title", new: "wording"},{old: "$field", new: "wording"}] },
    value :{ 
      validations : { },
      replacesValues : [{old: "$title", new: "value"},{old: "$field", new: "value"}] },
    field :{ 
      validations : { onBlur: [{ type:"REQUIRE"}]},
      replacesValues : [{old: "$title", new: "field"},{old: "$field", new: "field"}] },
         
    
    form :{}
  }

  const log = [{type:"SETTINGS", value: "Settings Step: ", style: {fontFamily:"sans-serif",fontSize:"18px",fontWeight:"bold", color : "Black"}}
  ,{type:"ADD", value: "Add $title", style: {fontFamily:"sans-serif",fontWeight:"normal", color : "Black"}}
  ,{type:"SELECT", value: "Select $title", style: {fontFamily:"sans-serif",fontWeight:"normal", color : "Black"}}
  ,{type:"UPDATE", value: "Update $title", style: {fontFamily:"sans-serif",fontWeight:"normal",color : "Black"} }
  ,{type:"DELETE", value: "Commit deleting", style: {fontFamily:"sans-serif",fontWeight:"normal", color : "rgb(206, 17, 38)"} }
  ,{type:"REQUIRE", value: "The $field is required", style: {fontFamily:"sans-serif", fontWeight:"normal",color : "rgb(206, 17, 38)"} }]
  
const templateEvent = { option:actions.event.email , Email : {details:[]}, Api : {details:[]}}
const templateDecision = { option:actions.decision.preConditions , PreConditions : {details:[]}, PostConditions : {details:[]}}
const templateTask = { option:actions.task.alert , Alert : {details:[]}}
const [settings, setSetting] = useState({  
  errors:[],
  loading:false,
  showDiscard:false,
  showLeave:false,
  option : actions.option.task,
  event : templateEvent,
  decision : templateDecision,
  task : templateTask,
  previousState : {option : actions.option.decision
    , event : { option:actions.event.email , Email : {details:[]}, Api : {details:[]}}
    , decision : { option:actions.decision.preConditions , PreConditions : {details:[]}, PostConditions : {details:[]}}
    , task : { option:actions.task.form , Form : {details:[]}}},
  processId : new URLSearchParams(useLocation().search).get("processId"),
  stepId : new URLSearchParams(useLocation().search).get("stepId"),
  stepGlobalId : new URLSearchParams(useLocation().search).get("stepGlobalId"),
  order : new URLSearchParams(useLocation().search).get("order")
  
});

const [customAlert, setCustomAlert] = useState({isVisible:false});

  var optionSample = { event: {id:0, item:"", value:"", option:actions.event.email , Email : {details:[]}, Api : {details:[]} }
                      , decision: {id:0, item:"", value:"", option:actions.decision.preConditions , PreConditions : {details:[]}, PostConditions : {details:[]} }
                      ,task: {id:0, item:"", value:"", option:actions.task.alert 
                      , automatic: false
                      , Policy : {details:[]}
                      , Alert : {option:actions.task.new, New:{details:[]} 
                      , Approved:{details:[]}, InProgress:{details:[]}, Resolved:{details:[]}, Done:{details:[]}}}}
  
  var optionItem = {id:1, option:"", type: {value : "Include"}
                      , key:{id:"", value:"", isClick:false}
                      , value:{id:"", read:true, execute:true, delete:true, done:true} 
                   }
  
  const isInputValid = useValidationInput();
  const currentProcessSteps = globalState.state.step.decisions.filter(process => process.id == settings.processId)[0].childs
    .map(step => {return {id:step.id, smallId:step.smallId, item:step.item }})
  //const setDataVariableInText = useSetDataVariableInText();

  const getCurrentOption = (current = settings)  => 
  {
    const option = current.option.toLocaleLowerCase()
    return current[option].values ? current[option].values.filter(item => item.id == current[option].id)[0] 
    : {}
  };

  const getTaskToCompare = (actualSettings) => {
    const task = getCurrentOption(actualSettings)
    return {item:task.item, value:task.value , duration:task.duration, estimated:task.estimated, priority:task.priority, Alert:task.Alert, Policy:task.Policy, Form:task.Form}
  };
  
  const getDecisionToCompare = (actualSettings) => {
    
    const decision = getCurrentOption(actualSettings)
   
    return {item:decision.item, value:decision.value, PreConditions:decision.PreConditions, PostConditions:decision.PostConditions}
  };

  const getEventToCompare = (actualSettings) => {
    
    const eventToCompare = getCurrentOption(actualSettings)
    
    return {item:eventToCompare.item, value:eventToCompare.value, Email:eventToCompare.Email, Api:eventToCompare.Api}
  };

  const isTaskFormActif  = () => {
    return getCurrentOption().option == actions.task.form 
  }
  
  const isEqual =() => {
    
    switch (settings.option) {   
  
      case actions.option.decision: {
        
        return _.isEqual(getDecisionToCompare(settings), getDecisionToCompare(settings.previousState))
      }
  
      case actions.option.task: {
        
        return _.isEqual(getTaskToCompare(settings), getTaskToCompare(settings.previousState)) 
        &&  ( !isTaskFormActif() || (settings.formData && _.isEqual(settings.formData.metaData, globalState.state.formData.metaData)))
      }

      case actions.option.event: {
        
        return _.isEqual(getEventToCompare(settings), getEventToCompare(settings.previousState))
      }
        
    }
  
    return false
   };
  
   
  const isChanged = !isEqual()

  const onSelectStep = (itemSelected) => {
    if (isChanged) 
      setSetting({...settings, showLeave: true})
    else
      setSetting({...settings, loaded: false, stepId:itemSelected.smallId})
   
  }
  
  useEffect(() => {
    
    if ( !settings.loaded ) {
      var settingsData = JSON.parse(JSON.stringify(settings));
      
      axiosOperation({method:"GET"
        , url: "https://flex-services.onrender.com/settingsStep/"+ settings.processId +"/"+ settings.stepId  +"/"+ settings.order  +"/"
        }, true).then(response => 
          { 
            
            if(response.managedError) {
              
              const result = response.result.data
              
              const resultTask = result.task.values.length > 0 ? result.task : templateTask
              const resultEvent = result.event.values.length > 0 ? result.event : templateEvent
              const resultDecision = result.decision.values.length > 0 ? result.decision : templateDecision
              
              const withForm = result.task.values.length > 0 && result.task.values[0].Form != null
              const formData = withForm ? result.task.values[0].Form.formData : undefined
              settingsData = {...settingsData, loaded:true, task:resultTask, event:resultEvent, decision:resultDecision
                , formData:formData}
              if (withForm) {
                              
                dispatch({
                  type: "INITIALIZE_FORM",
                  payload: {formData:formData, previousForms:result.previousForms},
                });
                
              } else

              {
                dispatch({
                  type: "REFRESH_FORM",
                  payload: {previousForms: result.previousForms},
                });
              
              
            } 


              /*
              if (result.task.values.length > 0) {
                //settingsData = {...settingsData, loaded:true, validation:{...settingsData.validation, ...result.validation}}
                settingsData = {...settingsData, loaded:true, task:result.task}
                
                dispatch({
                  type: "INITIALIZE_FORM",
                  payload: {metasData:result.task.values[0].Form.metasData, metaData:result.task.values[0].Form.metaData},
                });
                
              }
              if (result.event.values.length > 0) {
                //settingsData = {...settingsData, loaded:true,task:{...settingsData.task, ...result.task}}
                settingsData = {...settingsData, loaded:true,event:result.event}
              }
              if (result.decision.values.length > 0) {
                //settingsData = {...settingsData, loaded:true,task:{...settingsData.task, ...result.task}}
                settingsData = {...settingsData, loaded:true,decision:result.decision}
              }
              */
              updatePreviousState(settingsData)
              
              setSetting(settingsData)
            }
            else {
              
              setSetting({...settings, log:{text:response.text, style:{fontSize:"12px", color:"rgb(206, 17, 38"}, activeResendEmail:undefined}})
            }
          })
    }
  });
  
  const isItemInDiagram = (type, data, id) => {
    const n = data.length
    var i = 0
    var found = false
    while(i < n && !found) {
      const node = data[i]
      found = node.items.data.filter(current => current.list == type && current.item.id == id).length > 0
      i = i + 1
      const l = node.childs.length
      var k = 0
      while(k < l && !found) {
        found = node.childs[k].items.data.filter(current => current.list == type && current.item.id == id).length > 0
        k = k + 1
      }     
    };
    return found
  }

  const canDeleteItem = (data, option, id) => {
    
    switch (option) {
      case actions.validation.preConditions:
        return !isItemInDiagram ("Steps", data, id)
      case actions.validation.postConditions:
          return !isItemInDiagram ("Steps", data, id)
      case actions.task.policy:
        return !isItemInDiagram ("Steps", data, id)
      case actions.task.alert:
        return !isItemInDiagram ("Decisions", data, id)
    }
    
  }

  const changePolicy = (value, policyType, detail ) => {
    var settingsData = JSON.parse(JSON.stringify(settings));
    var currentOption = getCurrentOption(settingsData)
    
    currentOption[currentOption.option].details.filter(item => item.id == detail.id)[0][detail.type][policyType] = value;
     
   
    setSetting(settingsData)
  };

  const changeValue = (value, fieldId ,fieldName="value", detail = undefined) => {
    var settingsData = JSON.parse(JSON.stringify(settings));
    var currentOption = getCurrentOption(settingsData)
    
    if (detail) {
      if (isTaskAlertActif())
        currentOption = currentOption[currentOption.option.replace(" ","")]
      currentOption[currentOption.option.replace(" ","")].details.filter(item => item.id == detail.id)[0][detail.type].value = value;
     
    }
    else {
       
      //getCurrentOption(settingsData)[fieldName] = value;
      //getCurrentOption(settingsData)["fieldId"] = fieldId
      currentOption[fieldName] = value;
      currentOption["fieldId"] = fieldId
     
    }
    setSetting(settingsData)
  };

  const changeValues = (value, detail) => {
    var settingsData = JSON.parse(JSON.stringify(settings));
    var currentOption = getCurrentOption(settingsData)
    if (isTaskAlertActif())
      currentOption = currentOption[currentOption.option]
    currentOption[currentOption.option.replace(" ","")].details.filter(item => item.id == detail.id)[0][detail.parent][detail.child] = value;
     
   
    setSetting(settingsData)
  };

const replaceValue = (value, replaces) => {
  if( replaces )
    replaces.map(replace => value = value.replace(replace.old, replace.new)) 
  return value
}

const getTitle = () => {
  var replaces = currentSetting.replacesValues
  var currentType =  menu.operation.Settings
  var menuError = " "
   
  if (onError) {
    //const currentOption = isValidationActif() ? getCurrentOption().option : settings.option
    const currentOption = getCurrentOption().option 
    const currentError = settings.errors.filter(error => error.option == currentOption).slice(-1)[0]
    if (currentError) {
      currentType = currentError.type 
      replaces = currentError.replacesValues
    } else {
      const defaultError = settings.errors.slice(-1)[0]
      currentType = defaultError.type 
      replaces = defaultError.replacesValues
      
      menuError = isEventSubOption(defaultError.option) ? 
                    (isEventActif() ? " ( " : " ( Event --> ") + defaultError.option + " )" : 
                  isDecisionSubOption(defaultError.option) ? 
                    (isDecisionActif() ? " ( " : " ( Decision --> ") + defaultError.option + " )" :
                   (isTaskSubOption(defaultError.option) ? 
                    (isTaskActif() ? " ( " : " ( Task --> ") + defaultError.option + " )"
                    :  " ( " + defaultError.option + " )")
    } 
    
  } 
  
  return log.filter(
    log => log.type == currentType
  ).map( log =>  {return <span style = {log.style}>{replaceValue(log.value, replaces) + menuError}</span>})[0]
}

const fireEventKeyPressByMenu = (e, detail, event) => {
  const typeEvents = menu[detail.type].validations[event]
  var settingsData = JSON.parse(JSON.stringify(settings));
  
  settingsData.errors = settingsData.errors.filter(error => error.id != detail.id )

  if(!isInputValid({value: e.key}, typeEvents).isValid) {
    e.preventDefault()
  }
  setSetting(settingsData);
}


const fireEventByMenuAndConditionAndSetValue = (e, detail, event) => {
  
  var settingsData = JSON.parse(JSON.stringify(settings));
  
  const typeEvents = menu[detail.type].validations ? menu[detail.type].validations[event] : []
  const eventResponse = isInputValid({value: e.target.value}, typeEvents);
  
  if(eventResponse.isValid) {
    settingsData.errors = settingsData.errors.filter(error => !(error.id == detail.id && error.event == event) )
  }
  else {
    settingsData.errors.push({id:detail.id
      , option: isDecisionActif() ? getCurrentOption().option : settings.option
      , event:event, type:eventResponse.type, replacesValues: menu[detail.type].replacesValues})
  }
 
  setSetting(settingsData);
}

const getNodeTypes = (nodes, keys, type) => {
  nodes.map(node => {
    keys.push(node[type])
    getNodeTypes(node.childs, keys, type)
  })
}

const deleteTask = () => {
  var settingsData = JSON.parse(JSON.stringify(settings));
  axiosOperation({method:"DELETE"
      , url: "https://flex-services.onrender.com/task/"+ getCurrentOption().id  + "|" + settings.processId +"|"+ settings.stepId  +"/"
      , body:{id:globalState.state.company.id}
    }, true).then(response => 
    { 
      if(response.managedError) {
        const result = response.result.data
        settingsData = {...settingsData, loading:false, task:result.task.id == null ? templateTask : result.task}
        settingsData.previousState.task = settingsData.task
        
        setSetting(settingsData)
      }
      else {
        setSetting({...settings, log:{text:response.text, style:{fontSize:"12px", color:"rgb(206, 17, 38"}, activeResendEmail:undefined}})
      }
    })
}

const deleteDecision = () => {

  var settingsData = JSON.parse(JSON.stringify(settings));
  axiosOperation({method:"DELETE"
      , url: "https://flex-services.onrender.com/decision/"+ getCurrentOption().id + "|" + settings.processId +"|"+ settings.stepId  +"/"
    }, true).then(response => 
    { 
      if(response.managedError) {
        
        const result = response.result.data
        
        //settingsData = {...settingsData, loaded:true,validation:{...settingsData.validation, ...result.validation}}
        settingsData = {...settingsData, loading:false,decision:result.decision.id == null ? templateDecision : result.decision}
        settingsData.previousState.decision = settingsData.decision
        
        setSetting(settingsData)
      }
      else {
        //page error
        setSetting({...settings, log:{text:response.text, style:{fontSize:"12px", color:"rgb(206, 17, 38"}, activeResendEmail:undefined}})
      }
    })
}

const deleteEvent = () => {

  var settingsData = JSON.parse(JSON.stringify(settings));
  axiosOperation({method:"DELETE"
      , url: "https://flex-services.onrender.com/event/"+ getCurrentOption().id + "|" + settings.processId +"|"+ settings.stepId  +"/"
    }, true).then(response => 
    { 
      if(response.managedError) {
        
        const result = response.result.data
        
        settingsData = {...settingsData, loading:false,event:result.event.id == null ? templateEvent : result.event}
        settingsData.previousState.event = settingsData.event
        
        setSetting(settingsData)
      }
      else {
        //page error
        setSetting({...settings, log:{text:response.text, style:{fontSize:"12px", color:"rgb(206, 17, 38"}, activeResendEmail:undefined}})
      }
    })
}

const canAddFormData = (formData) => {
  return formData.metaData[0].metaData.length > 0
}

const setTask = () => {
  
  var settingsData = JSON.parse(JSON.stringify(settings));
  var formData = JSON.parse(JSON.stringify(globalState.state.formData));
  delete formData.log
  delete formData.menu
  delete formData.lists.validations
  axiosOperation({method:"POST"
      , url: "https://flex-services.onrender.com/task/"+ settings.stepId +"/"
      , body:{...settings.task, processId:settings.processId, values :[{...getCurrentOption(),  
        
        Form:canAddFormData(formData) ? {
          formData:formData
        } : undefined
      }]}
    }, true).then(response => 
    { 
      if(response.managedError) {
        
        const task = response.result.data
        
        //settingsData = {...settingsData, loaded:true,task:{...settingsData.task, ...result.task}}
        const withForm = task.values.length > 0 && task.values[0].Form != null
        const formData = withForm ? task.values[0].Form.formData  : undefined
        settingsData = {...settingsData, loading:false, task:task, formData:formData}
        settingsData.previousState.task = settingsData.task
        
        dispatch({
          type: withForm ? "INITIALIZE_FORM" : "REFRESH_FORM",
          payload: {formData:formData},
        });
        setSetting(settingsData)
      }
      else {
        //page error
        setSetting({...settings, log:{text:response.text, style:{fontSize:"12px", color:"rgb(206, 17, 38"}, activeResendEmail:undefined}})
      }
    })
}

const setDecision = (item) => {
  
  var settingsData = JSON.parse(JSON.stringify(settings));
  axiosOperation({method:"POST"
      , url: "https://flex-services.onrender.com/decision/"+ settings.stepId +"/"
      , body:{...settings.decision, processId:settings.processId,
         values : isDecisionPreConditionsActif() ? 
            [{...getCurrentOption(), PreConditions:item.conditions }] : 
            [{...getCurrentOption(), PostConditions:item.conditions}]}
    }, true).then(response => 
    { 
      if(response.managedError) {
        
        const decision = response.result.data
        
        //settingsData = {...settingsData, loaded:true,validation:{...settingsData.validation, ...result.validation}}
        settingsData = {...settingsData, loading:false, decision:decision}
        settingsData.previousState.decision = settingsData.decision
        
        setSetting(settingsData)
      }
      else {
        //page error
        setSetting({...settings, log:{text:response.text, style:{fontSize:"12px", color:"rgb(206, 17, 38"}, activeResendEmail:undefined}})
      }
    })
}

const setTaskEvent = (item = undefined) => {

  var settingsData = JSON.parse(JSON.stringify(settings));
  axiosOperation({method:"POST"
      , url: "https://flex-services.onrender.com/event/"+ settings.stepId +"/"
      , body:{...settings.event, processId:settings.processId
        , values : item == undefined ? [getCurrentOption()] : [{...getCurrentOption()
          
          , Api:item.api }]
      }
    }, true).then(response => 
    { 
      if(response.managedError) {
        
        const taskEvent = response.result.data
        
        settingsData = {...settingsData, loading:false, event:taskEvent}
        settingsData.previousState.event = settingsData.event
        
        setSetting(settingsData)
      }
      else {
        //page error
        setSetting({...settings, log:{text:response.text, style:{fontSize:"12px", color:"rgb(206, 17, 38"}, activeResendEmail:undefined}})
      }
    })
}

const fireEventOnSaveValue = (event = "onBlur", item=undefined) => {
  
  var settingsData = JSON.parse(JSON.stringify(settings));
  
  setSetting({...settingsData, loading:true})
  //var typeEvents = [] //currentSetting[event]
  
  switch (settingsData.option) {   

    case actions.option.decision: {
      setDecision(item)
      break;
    }

    case actions.option.event: {
      let detailsToValidate = []
      const decisionSettings = ["Email", "Api"];
      const settingsToValidate = getCurrentOption(settingsData) 
      decisionSettings.map(option =>
        settingsToValidate[option] && settingsToValidate[option].details 
        && settingsToValidate[option].details.length > 0 && detailsToValidate.push(settingsToValidate[option].details)
      )
           
      detailsToValidate = detailsToValidate.flat(Infinity)
      
      let keyData = detailsToValidate.map(detail =>{return {option:detail.option, key:detail.key }})
      let keyEvents = menu.key.validations[event]
      keyData.map(itemData => {
        let eventResponse = isInputValid({value: itemData.key.value}, keyEvents);
        if(!eventResponse.isValid) 
          settingsData.errors.push({id:itemData.key.id, option: itemData.option, event:event, type:eventResponse.type
            , replacesValues: menu.key.replacesValues})
        }
      )
      let valueData = detailsToValidate.map(detail => {return {option:detail.option, value:detail.value }})
      let valueEvents = menu.value.validations[event]
      valueData.map(itemData => {
        let eventResponse = isInputValid({value: itemData.value.value}, valueEvents);
        if(!eventResponse.isValid) 
          settingsData.errors.push({id:itemData.value.id, option: itemData.option, event:event, type:eventResponse.type
            , replacesValues: menu.value.replacesValues})
        }
      )

      if (settingsData.errors.length == 0) setTaskEvent(item)
  
        
      break;
    }

    case actions.option.task: {
      
      let detailsToValidate = []
      const taskSettings = ["Policy", "Alert"];
      const settingsToValidate = getCurrentOption(settingsData) 
      taskSettings.map(option => {
        var settingsDataOption = settingsToValidate[option]
        if (settingsDataOption) {
          
          currentSetting.task.alert.options.forEach (opt => {
            var settingsDataOptionToValidate = settingsDataOption[opt.replace(" ","")]
          
            settingsDataOptionToValidate  && settingsDataOptionToValidate.details 
              && settingsDataOptionToValidate.details.length > 0 && detailsToValidate.push(settingsDataOptionToValidate.details)
          })
        }
      })
           
      detailsToValidate = detailsToValidate.flat(Infinity)
      
      let keyData = detailsToValidate.map(detail =>{return {option:detail.option, key:detail.key }})
      let keyEvents = menu.key.validations[event]
      keyData.map(itemData => {
        let eventResponse = isInputValid({value: itemData.key.value}, keyEvents);
        if(!eventResponse.isValid) 
          settingsData.errors.push({id:itemData.key.id, option: itemData.option, event:event, type:eventResponse.type
            , replacesValues: menu.key.replacesValues})
        }
      )
      let valueData = detailsToValidate.map(detail => {return {option:detail.option, value:detail.value }})
      let valueEvents = menu.value.validations[event]
      valueData.map(itemData => {
        let eventResponse = isInputValid({value: itemData.value.value}, valueEvents);
        if(!eventResponse.isValid) 
          settingsData.errors.push({id:itemData.value.id, option: itemData.option, event:event, type:eventResponse.type
            , replacesValues: menu.value.replacesValues})
        }
      )
      if (settingsData.errors.length == 0) setTask()
      break;
    }
      
  }
 
  
  if (settingsData.errors.length != 0) setSetting(settingsData);
 
  if (item) toggle()
}

const getCurrentSettings = (type="step" ) => {
  const menu = isDecisionActif() ?  "decision" : "api"
  
  return { currentEvent:currentSetting.currentEvent ,  menu:menu, type:type,
    errors:[],
    option :isDecisionActif() ? "Conditions" : "Api",
    api : getApi(menu, type),
    conditions:getCondition(menu, type)}
}

const getCondition = () => {       
  var currentCondition = getCurrentOption()
  var currentConditionDetail = undefined
  if (currentCondition)
    currentConditionDetail = isDecisionPreConditionsActif() ? currentCondition.PreConditions : currentCondition.PostConditions
  
  if (!currentConditionDetail) currentConditionDetail = {value:"", isClick:false}
    
  return currentConditionDetail 
}

const getApi = () => {
  var currentApi = getCurrentOption()
 
  if (isEventApiActif() && currentApi){ 
    return currentApi.Api
  }
  else 
    return {method: "GET", option:globalState.state.formData.actions.api.params , Params : {details:[]}}
}

const getOptionForm = (value) => {
  
  switch (value) {
    case actions.option.event:
    case actions.option.task:
    case actions.option.decision:
      return getOption()    
  }
  
}



const getOptionDescription = (width = "100%") => {
  const fieldId = settings.option + "DescriptionValue"
  return <div id={settings.option + "DescriptionValue"} style={{  display: "flex", marginRight: "5px"}} >
          <textarea
            className="textBox"
            value={getCurrentOption().value? getCurrentOption().value : ""}
            //onKeyPress={(e) => fireEventKeyPress(e, {id : fieldId},actions.event.type.onkeyPress) }
            //onBlur={(e) => fireOtherEvent(e, {id : fieldId},actions.event.type.onBlur) }
            onChange={(e) => changeValue(e.target.value, fieldId) }
            style={{width: width, height: "53px", marginLeft: "5px"}}/>
          
        </div>
}

const getTextOptionValue = (inputValue, detailValue) => {
  
  const value = Array.isArray(inputValue) ? getValueFromArray(inputValue, undefined, undefined, undefined, detailValue).name :inputValue
  return value ? value : ""
}
const getDetailOptionSettingValue = (id, type) => {
  const current = getCurrentOption()
  var currentOptionSetting = current[current.option]
  if (isTaskAlertActif())
    currentOptionSetting = currentOptionSetting[currentOptionSetting.option.replace(" ","")]
  currentOptionSetting = currentOptionSetting.details.filter(item => item.id == id);
  if (currentOptionSetting) {
    
    return getTextOptionValue(currentOptionSetting[0][type].value, currentOptionSetting[0][type].checkedsPath)
  }
  else
    return ""
}


const isKeyColonne = (type) => {
  
  return type == actions.decision.type.key
}

const isValueColonne = (type) => {
  
  return type == actions.decision.type.value
}

const isClickOnHide = (isHide) => {
  
  return isHide[actions.decision.type.key].isClick
}

const getCommandIcon = (type, isHide) => {
  return (isTaskPolicyKey(type) || isTaskAlertKey(type) || isEventEmailtKey(type)) && <MiddleEditCommand className ="hoverBlue"/> 
}

const isEventEmailActif  = () => {
  return getCurrentOption().option == actions.event.email 
}

const isEventApiActif  = () => {
  return getCurrentOption().option == actions.event.api 
}

const isTaskPolicyActif  = () => {
  return getCurrentOption().option == actions.task.policy 
}

const isTaskAlertActif  = () => {
  return getCurrentOption().option == actions.task.alert 
}


const isDecisionPreConditionsActif  = () => {
  return getCurrentOption().option == actions.decision.preConditions 
}

const isTaskPolicyKey = (type) => {
  return isTaskActif() && isTaskPolicyActif() && type == actions.task.type.key 
}

const isTaskAlertKey = (type) => {
  
  return isTaskActif() && isTaskAlertActif() && type == actions.task.type.key 
}

const isEventEmailtKey = (type) => {
  
  return isEventActif() && isEventEmailActif() && type == actions.event.type.key 
}

const onClickEditOperand = (item, type, e = undefined) => {
  if (e) e.preventDefault();
  
  var settingsData = JSON.parse(JSON.stringify(settings));
  var currentOption = getCurrentOption(settingsData)
  var isOpen = true

  
  if (isTaskActif() || isEventEmailActif()) {
    
    let currentClickSettings = currentOption[currentOption.option] 
    if (isTaskAlertActif()) currentClickSettings = currentClickSettings[currentClickSettings.option.replace(" ","")] 
    isOpen = currentClickSettings.details.filter(current => current.id == item.id)[0][type].isClick
    currentClickSettings.details.filter(current => current.id == item.id)[0][type].isClick = !isOpen
  }

  

  /*if (isConditionsActif()) {
      if (isConditionsDetailsSettings(type)) {
        let currentClickSettings = getCurrentConditions(settingsData)
        isOpen = currentClickSettings.details.filter(current => current.id == item.id)[0][type].isClick
        currentClickSettings.details.filter(current => current.id == item.id)[0][type].isClick = !isOpen
      } else {
        
        isOpen = settingsData.conditions.isClick
        settingsData.conditions.isClick = !isOpen
      }
  
    }*/

  setSetting(settingsData)
}

const getTypeInput = (type, item) => {
  return isValueColonne(type) && isClickOnHide(item) ? "password" : "text"
}

const isInError = (id)=> {
   
  return settings.errors.filter(error => error.id == id).length > 0
}

const getInput =(item, type, fieldId, placeHolder, option) => {
  
  return  <input
    className="textBoxWithoutBorder"
    //type = {getTypeInput(type, item)}
    placeholder = {placeHolder}
    maxLength = {option.size}
    readOnly = {isTaskPolicyKey(type) || isTaskAlertKey(type)}
    value={getDetailOptionSettingValue(item.id, type)}
    onKeyPress={(e) => fireEventKeyPressByMenu(e, {id:fieldId, type:type  }, actions.events.type.onkeyPress) }
    onBlur={(e) => fireEventByMenuAndConditionAndSetValue(e, {id:fieldId, type:type  }, actions.events.type.onBlur) }
    onChange={(e) => changeValue(e.target.value, fieldId, "value",{id:item.id, type:type  }) }
    style={{width: option.width, fontSize: "12px",fontFamily: "Arial", paddingTop: "3px"
    , border: isInError(fieldId) ? "1px solid rgb(206, 17, 38)" : undefined}}/>

}

const getCurrentUserEmail = () => {
  return globalState.state.variables.users.map(user => {
    return {...user, childs:user.childs.filter(child => child.item == "@EMail")}
    }
  )
}

const getCustomData = (userList) => {
  if (isTaskPolicyActif())
    return globalState.state.step.profils
  if (isTaskAlertActif() || isEventEmailActif())
    return [...globalState.state.step.profils, ...userList()]
}

const getCustomTitle = () => {
  if (isTaskPolicyActif())
    return "Select Profil"
  if (isTaskAlertActif() || isEventEmailActif())
    return "Select Profil"
}

const getTextRelation = (item, type, fieldId, placeHolder, option ={width : "250px"}) => {
  
  return <div id ={fieldId} style={{  display: "flex", marginRight: "5px"}} >
          {getInput(item, type, fieldId, placeHolder, option)}
          {<div onClick={(e) => onClickEditOperand(item, type, e) } >
            {getCommandIcon(type, item[type].isClick)}
          </div>}
          { item[type].isClick && <TreeViewDialog  
              onSaveSelection = {(e, selectedsItems) =>  onSaveSelection(e, selectedsItems, fieldId, {id:item.id, type:type  })}
              onClose = {() => onClickEditOperand(item, type)} 
              withCheckBox = {true}
              leafSelection = {true}
              singleChecked = {isTaskPolicyActif()}
              customData = {getCustomData(() => getCurrentUserEmail())} //{props.formData}
              title = {getCustomTitle()}
              //ancestorId = {option.ancestorId}
              //typeData = {settings.data && settings.data[settings.option.toLowerCase()].treeDataType}
              parentId = {fieldId} type = {"field"} />}
      </div>
}

const getSeparator = () => {
  return <div style={{  height: "17px", margin:"5px 15px 0px 0px",  borderRight:"2px solid rgb(223, 221, 221)" }} /> 
}

const onSelectOperator = (id, itemSelected) => {
  var settingsData = JSON.parse(JSON.stringify(settings));
  const current = getCurrentOption(settingsData)
  var currentOptionSetting = current[current.option]
  currentOptionSetting.details.filter(item => item.id == id)[0].type = {value : itemSelected.item};
        
  setSetting(settingsData)
}

const getTaskItem = (item)=> {
  const current = getCurrentOption()
  const option = settings.option.toLocaleLowerCase()
  const keyId = item.key.id //settings.option + getCurrentOption().option + actions.validation.type.key + item.id
  const valueId = item.value.id //settings.option + getCurrentOption().option + actions.validation.type.value + item.id
  
  const width = "300px"
  return <div key = {item.id} className ="gridLine">
        {getTextRelation(item, actions[option].type.key, keyId, "Profil", {width : width, size:25 } )}
        {getSeparator()}
        {<div style={{  minWidth: "82px", maxWidth: "82px"}} >
        <DropDownListNew
          currentData={[{id:1, item:"Include"},{id:2, item:"Exclude"}]}
          minWidth={"30px"}
          initialValue={item.type.value}
          id={"OperatorList" + item.id}
          onDropDownItemClick={(itemSelected) => onSelectOperator(item.id, itemSelected)}
          onlyLabel={false}
        />
        </div>}
        {getSeparator()}
        {getPolicyItem(item)}

        {<div
          onClick={(e) => onClickDeleteOptionSetting(e, item.id, [keyId, valueId]) } 
          style ={{ marginLeft: "5px" }}>
          <CloseCommand className ="hoverRed"/>
        </div>}
       
  </div> 
}

const onSaveEdition = (id, format, fieldId) => {
  var settingsData = JSON.parse(JSON.stringify(settings));
  var currentOption = getCurrentOption(settingsData)
  if (isTaskAlertActif() ) currentOption = currentOption[currentOption.option.replace(" ","")]
  var alertMessage = currentOption[currentOption.option.replace(" ","")].details.filter(item => item.id == id)[0]
  alertMessage["body"] = {value: format.itemValue.textContent, format:format, fieldId:fieldId}
 
  if (format.itemValue.checkedDetail != null) {
    if (alertMessage.checkedDetail)
      alertMessage["checkedDetail"] = [...alertMessage.checkedDetail, format.itemValue.checkedDetail]
    else
      alertMessage["checkedDetail"] = [format.itemValue.checkedDetail]
  }
  settingsData.errors = settingsData.errors.filter(error => error.id != fieldId )
  
  setSetting(settingsData)
}


const getDetailSetting = (id, parent, child) => {
  const current = getCurrentOption()
  var currentOptionSetting = current[current.option]
  if (isTaskAlertActif())
    currentOptionSetting = currentOptionSetting[currentOptionSetting.option.replace(" ","")]
  currentOptionSetting = currentOptionSetting.details.filter(item => item.id == id);
  if (currentOptionSetting) {
    const value = currentOptionSetting[0][parent][child]
    return value
  }
  else
    return ""
}

const getFrequency = (item)=> {
 return <div style={{  display: "flex" }}>
          <span style={{  userSelect: "none", fontFamily:"arial, sans-serif", fontSize: "14px", paddingTop: "10px"}} >One Times:</span>
          <div style={{ paddingTop: "5px", marginRight: "10px" }}>
            <CheckBox checked={item.frequency.oneTimes} click={() => changeValues(!item.frequency.oneTimes,{id:item.id, parent:"frequency", child:"oneTimes"  })}/>
          </div>
          {!item.frequency.oneTimes &&
            <div style={{  display: "flex" }}>
              <span style={{  userSelect: "none", fontFamily:"arial, sans-serif", marginRight:"5px", fontSize: "14px", paddingTop: "10px"}} >Each:</span>
              <input
                maxLength={3}
                className="textBoxWithoutBorder"
                value={getDetailSetting(item.id, "frequency", "number")}
                onKeyPress={(e) => isNaN(e.key) && e.preventDefault() }
                onChange={(e) => changeValues(e.target.value,{id:item.id, parent:"frequency", child:"number"  }) }
                style={{width: "30px", fontSize: "14px",fontFamily: "Arial", marginRight:"5px",paddingTop: "5px",marginTop: "5px"}}/>
              <div style={{  minWidth: "82px", maxWidth: "82px", marginRight: "10px",marginTop: "2px"}} >
                <DropDownListNew
                  currentData={[{id:1, item:"second"},{id:2, item:"minute"},{id:3, item:"hour"},{id:4, item:"day"},{id:5, item:"month"},{id:6, item:"year"}]}
                  minWidth={"30px"}
                  initialValue={item.frequency.type}
                  id={"FrequenceList" + item.id}
                  onDropDownItemClick={(itemSelected) => changeValues(itemSelected.item,{id:item.id, parent:"frequency", child:"type"  })}
                  onlyLabel={false}
                />
              </div>
            </div>}
        </div> 
}

const getAlertItem = (item)=> {
  const currentOption = getCurrentOption()
  
  const option = settings.option.toLocaleLowerCase()
  const keyId = item.key.id 
  const valueId = item.value.id 

  const width = "695px"
  //const index = currentSetting.task.alert.options.findIndex(opt => opt == item.option) + 1
  const rawFildId = item.id +"0" //index + "" +
  const rawEditorId = "Editor" + item.option + rawFildId
  
  return <div key = {item.id} className ="gridLine" style={{  display: "block" }}>
          
        {isTaskAlertActif() && getFrequency(item, option)}
        <div style={{  display: "flex" }}>
          {getTextRelation(item, actions[option].type.key, keyId, "To", {width : width, size:25 } )}
          {<div
            onClick={(e) => onClickDeleteOptionSetting(e, item.id, [keyId, valueId]) } 
            style ={{ marginLeft: "5px" }}>
            <CloseCommand className ="hoverRed"/>
          </div>}
        </div>
        <div style={{  display: "flex" }}>
          {getTextRelation(item, actions[option].type.value, valueId, "Object", {width : width, size:25 } )}
        </div>
        <div style={{  width: "745px" }}>
          <RichTextEditor key = {rawEditorId}
                modalType = {"field"}
                //modalData={[]}
                customModalData={getCustomData(() => { return globalState.state.variables.users})}
                //isInError={isInError(rawEditorId)}
                format={item.body && item.body.format}
                modalParentId={keyId}
                customModalTitle = {getCustomTitle()}
                data={{ id: rawFildId}}
                
                width = "100px"
                onSaveEdition = {(data) => onSaveEdition(item.id, data, rawEditorId)} 
                style ={{ height: "200px", 
                  border: isInError(rawEditorId) ? "1px solid rgb(206, 17, 38)" : "1px solid rgb(223, 221, 221)"
                }} 
                /> 
        </div>
  </div> 
}

const getPolicyItem = (item)=> {
    
  
  const option = settings.option.toLocaleLowerCase()
    
  return <div style={{  display: "flex", width: "280px"}} >
        <span style={{  userSelect: "none"}} >read:</span>
        <CheckBox checked={item.value.read} click={() => changePolicy(!item.value.read, "read",{id:item.id, type:actions[option].type.value  })}/>
        <span style={{  userSelect: "none"}}>execute:</span>
        <CheckBox checked={item.value.execute} click={() => changePolicy(!item.value.execute, "execute",{id:item.id, type:actions[option].type.value  })}/>
        <span style={{  userSelect: "none"}} >delete:</span>
        <CheckBox checked={item.value.delete} click={() => changePolicy(!item.value.delete, "delete",{id:item.id, type:actions[option].type.value  })}/>
        <span style={{  userSelect: "none"}} >done:</span>
        <CheckBox checked={item.value.done} click={() => changePolicy(!item.value.done, "done",{id:item.id, type:actions[option].type.value  })}/>

        </div>
}

const getOptionItem = (item)=> {
  const current = getCurrentOption()
  const option = settings.option.toLocaleLowerCase()
  const keyId = item.key.id //settings.option + getCurrentOption().option + actions.validation.type.key + item.id
  const valueId = item.value.id //settings.option + getCurrentOption().option + actions.validation.type.value + item.id
  const isConditionActif = current.option == actions.decision.preConditions || current.option == actions.decision.postConditions || current.option == actions.event.email || current.option == actions.event.api
  const width = isConditionActif ? "221px" : "270px"
  return <div key = {item.id} className ="gridLine">
        {getTextRelation(item, actions[option].type.key, keyId, "Wording", {width : width, size:25 } )}
        {getSeparator()}
        {isConditionActif && <div style={{  minWidth: "80px", maxWidth: "80px"}} >
        <DropDownListNew
          currentData={[{id:1, item:"Private"},{id:2, item:"Public"}]}
          minWidth={"30px"}
          initialValue={item.type.value}
          id={"OperatorList" + item.id}
          onDropDownItemClick={(itemSelected) => onSelectOperator(item.id, itemSelected)}
          onlyLabel={false}
        />
        </div>}
        {isConditionActif && getSeparator()}
        {getTextRelation(item, actions[option].type.value, valueId, "Comment", {width : width, size:50})}

        {<div
          onClick={(e) => onClickDeleteOptionSetting(e, item.id, [keyId, valueId]) } 
          style ={{ marginLeft: "5px" }}>
          <CloseCommand className ="hoverRed"/>
        </div>}
       
  </div> 
}

const onSaveSelection = (e, selectedsItems, fieldId, detail = undefined) => {
  e.preventDefault();
  
  var settingsData = JSON.parse(JSON.stringify(settings));
  
  settingsData.errors = settingsData.errors.filter(error => error.id != fieldId )  
  if (isTaskActif() || isEventEmailActif()) { //
    var currentOption = getCurrentOption(settingsData)
    if (detail ) { //&& isTaskActif()
      currentOption = currentOption[currentOption.option]
      if (isTaskAlertActif()) currentOption = currentOption[currentOption.option.replace(" ","")]
      currentOption.details.filter(item => item.id == detail.id)
      .map(item => {
        item[detail.type].value = selectedsItems.checkeds;
        item[detail.type].checkedsPath = selectedsItems.checkedsPath;
        item[detail.type].isClick = false;  
      } )
    }
  }
  
  setSetting(settingsData)
}

const onClickAddOptionSetting = (e) => {
  e.preventDefault();
  const option = settings.option.toLocaleLowerCase()
  var settingsData = JSON.parse(JSON.stringify(settings));
  var currentOption = getCurrentOption(settingsData)
  //var current = getCurrentOption(settingsData)[getCurrentOption().option]
  var current = currentOption[currentOption.option]
  //var keyId = settings.option + getCurrentOption().option + actions[option].type.key 
  //var valueId = settings.option + getCurrentOption().option + actions[option].type.value  
  //optionItem.option = getCurrentOption().option

  var keyId = settings.option + currentOption.option 
  var valueId = settings.option + currentOption.option 
  optionItem.option = currentOption.option
  
  if (isTaskAlertActif()) {
    optionItem["frequency"] = {id:"", oneTimes:true, number:"30",type:"minute"}
    optionItem.option = current.option.replace(" ","")
    current = current[optionItem.option]
    keyId = keyId + optionItem.option
    valueId = valueId + optionItem.option
    
  }
  keyId = keyId + actions[option].type.key 
  valueId = valueId + actions[option].type.value 
 
  
  if (optionItem.option == actions.decision.preConditions || optionItem.option == actions.decision.postConditions) optionItem.type = {value : "Private"}
  if (current.details.length > 0) {
    //getCurrentOption(settingsData)[getCurrentOption().option].maxDetailsId = getCurrentOption(settingsData)[getCurrentOption().option].maxDetailsId + 1
    //getCurrentOption(settingsData)[getCurrentOption().option].detailsId = getCurrentOption(settingsData)[getCurrentOption().option].maxDetailsId 
    //optionItem.id = getCurrentOption(settingsData)[getCurrentOption().option].detailsId
    current.maxDetailsId = current.maxDetailsId + 1
    current.detailsId = current.maxDetailsId 
    optionItem.id = current.detailsId
    optionItem.key.id = keyId + optionItem.id
    optionItem.value.id = valueId + optionItem.id 
    current.details.push(optionItem)
  }
  else {
    //getCurrentOption(settingsData)[getCurrentOption().option]["detailsId"] = 0
    //getCurrentOption(settingsData)[getCurrentOption().option]["maxDetailsId"] = 0
    current["detailsId"] = 1 //0 begin with 1 because template begin with 0 (New policy or New alert)
    current["maxDetailsId"] = 1 //0
    optionItem.key.id = keyId + 1 //+ 0
    optionItem.value.id = valueId + 1 //+ 0
    current.details = [optionItem]
 }
 
  setSetting(settingsData)
}

const updatePreviousData = (settingsData) => {
 
  if ( isDecisionActif() ) { //actions.option.validation == settings.option
    settingsData.decision = settingsData.previousState.decision
   
  }
  if ( isTaskActif() ) { //actions.option.task == settings.option
    
    if (isTaskFormActif())
      dispatch({
        type: "INITIALIZE_FORM",
        payload: {formData:settingsData.formData},
      });
    
    settingsData.task = settingsData.previousState.task
  } 
  if ( isEventActif() ) { //actions.option.task == settings.option
    settingsData.event = settingsData.previousState.event
   
  } 

  settingsData.showDiscard = false
  settingsData.showLeave = false
  settingsData.errors = []
}

const onDiscard = (e) => {
  e.preventDefault();
  var settingsData = JSON.parse(JSON.stringify(settings));
  updatePreviousData(settingsData)
  setSetting(settingsData)
}


const onLeave = (e) => {
  e.preventDefault();
  var settingsData = JSON.parse(JSON.stringify(settings));
  
  updatePreviousData(settingsData)
  if (settingsData.next) {
        
    if ( isTaskFormActif() && isTaskSubOption(settingsData.next))
      getCurrentOption(settingsData).option = settingsData.next
    else {
      settingsData.option = settingsData.next
      settingsData.previousState.option = settingsData.next
   }
    settingsData.next = undefined
  }
 
  setSetting(settingsData)
  //if (settingsData.option == actions.option.decision) toggle()
 
}

const onClickDeleteOptionSetting = (e, id, lineIds) => {
  var canDeleteCurrentOption = false 
  e.preventDefault();
  var settingsData = JSON.parse(JSON.stringify(settings));
  var currentOption = getCurrentOption(settingsData)
  if (isTaskAlertActif() )
    currentOption = currentOption[currentOption.option]
  if (canDeleteCurrentOption) {
     
    currentOption[currentOption.option.replace(" ","")].details = currentOption[currentOption.option.replace(" ","")].details.filter(condition => condition.id != id)
    settingsData.errors = settingsData.errors.filter(error =>  !lineIds.includes(error.id) )
    setSetting(settingsData)
  } else {
    if (isTaskActif()) 
      setCustomAlert({...alert, isVisible:true, text:"Can't delete this value because it's configured."})
      
    else if (isDecisionActif()) 
      setCustomAlert({...alert, isVisible:true, text:"Can't delete this value because it's configured."})
      
    
  }
}

const onClickValid = (e, detail) => {
  
  const type = settings.option.toLocaleLowerCase()
  if (e) e.preventDefault();
  var itemToUpdate = optionSample[settings.option.toLocaleLowerCase()] 
  var settingsData = JSON.parse(JSON.stringify(settings));
  
    switch (detail.operation) {
      case menu.operation.Add:{   
          
        if (settingsData[type].values) {
          
          //settingsData[type].maxId = settingsData[type].maxId + 1
          settingsData[type].id = uuid.v4() //settingsData[type].maxId 
          itemToUpdate.id =  settingsData[type].id
          itemToUpdate.item = detail.value
          
          settingsData[type].values.push(itemToUpdate)
         
        }
        else {
          settingsData[type] = {id : uuid.v4(), maxId :0} //{id : 0, maxId :0}
          //settingsData[type]["maxId"] = 0
          
          itemToUpdate.id = settingsData[type].id
          itemToUpdate.item = detail.value
          settingsData[type].values = [itemToUpdate]
        }
       
        setSetting(settingsData)              
        break;
      }
      case menu.operation.Update:{
        settingsData[type].values
        .filter(item => item.id == settingsData[type].id)
        .map(current => current.item = detail.value)
        setSetting(settingsData)
        break;
      }

      case menu.operation.Delete:{
        
        setSetting({...settingsData, loading:true})
        if (isDecisionActif(settingsData.option)) { //(settingsData.option == actions.option.validation)
         
          deleteDecision()
        }
        if (isTaskActif(settingsData.option)) { //(settingsData.option == actions.option.task) 
          
          deleteTask()
        }

        if (isEventActif(settingsData.option)) { //(settingsData.option == actions.option.task) 
          
          deleteEvent()
        }
        break;
      }
    }
   
  
}

const getOptionList = ()=> {
  const option = settings.option.toLocaleLowerCase()
  return settings[option].values ? 
    settings[option].values.map(valueItem => { return {id : valueItem.id, item:valueItem.item }})
    : []
}

const getSubOption  = (current) => {
  const option = settings.option.toLocaleLowerCase()
  switch (current.option) {
    case actions.task.policy:
      return current[current.option].details.map(item => getTaskItem(item))
    case actions.task.form:
      return <FormSettings />
    case actions.task.alert:
      return getAlertOption ()
    case actions.event.email:
      return current[current.option.replaceAll(" ","")].details.map(item => getAlertItem(item))
    case actions.decision.preConditions:
    case actions.decision.postConditions:
    case actions.event.api:
        return 
    default:
      return current[current.option].details.map(item => getOptionItem(item))
  }
}

const getAlertOption = () => {
  const currentOption = getCurrentOption()
  const currentAlert = currentOption[currentOption.option]
  
  return (
    <div id ="AlertOption">
      <div className ="gridSettingStepLine" >
        <div className="modal-line">
          {currentSetting.task.alert.options.map((item, index) => getAlertParams(item, index))}
        </div>
        { <div onClick={(e) => onClickAddOptionSetting(e) } 
            style ={{ marginLeft: "auto", paddingRight:"3px", marginTop:"5px" }}>
          <AddCommand className ="hoverGreen"/>
        </div>}
      </div>
      <div >
        {currentAlert && currentAlert[currentAlert.option.replaceAll(" ","")].details.map(item => getAlertItem(item))}
      </div>
  </div>)
}

const getAlertParams = (optionText, index) => {
  const currentOption = getCurrentOption()
  
  return <div key={"ApiResponse" + index} className="modal-list" onClick={() => setAlertOption(optionText)} >
          <div style={{marginRight: "20px", userSelect:"none", 
           borderBottom: optionText == currentOption[currentOption.option].option ? "2px Solid dodgerblue" : "none"}}>
            {optionText}
          </div> 
        </div>
}

const setAlertOption = (optionValue) => {
  var settingsData = JSON.parse(JSON.stringify(settings));
  var currentOption = getCurrentOption(settingsData)
  currentOption[currentOption.option].option =optionValue
  setSetting(settingsData)
}

const getOption = () => {
  const current = getCurrentOption()
  const option = settings.option.toLocaleLowerCase()
  
  return (
    <React.Fragment>
      {getOptionConfig(current, "200px")}
      {current.option ? 
      <React.Fragment>
        <div className ="gridSettingStepLine" >
          <span>
            Description:
          </span>
          <div>
            {getOptionDescription("660px")}
          </div>
        </div>   
     
      <div className ="gridSettingStepLine" >
        {currentSetting[option].options.length > 1 && 
          <div className="modal-line">
            {currentSetting[option].options.map((item, index) => getOptionParams(item, index))}
          </div>}
     
        { (isTaskPolicyActif() || isEventEmailActif()) && <div onClick={(e) => onClickAddOptionSetting(e) } 
            style ={{ marginLeft: "auto", paddingRight:"3px", marginTop:"5px" }}>
          <AddCommand className ="hoverGreen"/>
        </div>}
      </div>   
      <div >
        { current[current.option] && getSubOption(current)}
      </div>
      </React.Fragment>:null}

  </React.Fragment>)
}

const getNode = (nodes, parentId) => {

  let node = nodes.map(child => {
    if (child.id == parentId)
      return child
    else
      return getNode(child.childs, parentId)
  })
  
  return node.flat(Infinity)
}

const saveConfig = (type, itemSelected) => {
 
    var settingsData = JSON.parse(JSON.stringify(settings));
    var currentOption = getCurrentOption(settingsData)
    if (currentOption) {
      currentOption[type] = itemSelected
      setSetting(settingsData)
    }
  
}

const getOptionConfig = (current, width = "100%") => {
  const fieldId = settings.option + "ConfigValue"
  const currentConfigOption = getCurrentOption()
  return <div id={settings.option + "ConfigValue"} style={{  display: "flex", marginBottom: "5px"}} >
            <div style ={{ width: "245px" }}>
              <EditableDropDownList
                id="OptionList"
                title="Name:"
                initialValue={current ? current.item: ""}
                currentData={getOptionList()}
                policy={{
                  canAdd : !isChanged, 
                  canEdit : currentConfigOption.option != undefined, 
                  canDelete : currentConfigOption.option != undefined }}
                type = {"field"}
                onDropDownItemClick={(itemSelected) => onSelect(itemSelected)}
                width = "200px"
                style = {{ }}
                onClickValid={(e, detail) => onClickValid(e, detail)}/>
            </div>
            { isTaskActif() &&
            <React.Fragment>
              <span style ={{ userSelect: "none", fontWeight:"bold",marginLeft: "10px", marginTop: "2px",marginRight: "10px",fontSize:"14px" , fontFamily:"sans-serif"  }}>Priority: </span>
              <div style ={{ marginTop: "-4px" }}>
                <DropDownListNew
                  currentData={[{ id:1, item: "Low"},{ id:2, item: "Medium"},{ id:3, item: "High"},{ id:4, item: "Critical"} ]}
                  minWidth={"30px"}
                  initialValue={currentConfigOption.priority ? currentConfigOption.priority.item : "" }
                  id={"ProrityList"}
                  onDropDownItemClick={(itemSelected) => saveConfig("priority", itemSelected)}
                  onlyLabel={false}
                />
              </div>
              <span style={{ userSelect: "none",fontWeight:"bold",  marginLeft: "10px", marginTop: "2px",marginRight: "10px",fontSize:"14px" , fontFamily:"sans-serif"  }} >Estimated Time:</span>
              <input
                maxLength={3}
                className="textBoxWithoutBorder"
                value={currentConfigOption.duration != undefined ? currentConfigOption.duration : 30 }
                onKeyPress={(e) => isNaN(e.key) && e.preventDefault() }
                onChange={(e) => saveConfig("duration", e.target.value) }
                style={{width: "30px", fontSize: "14px", marginRight:"5px", marginTop: "-2px"}}/>
              <div style={{  marginTop: "-4px"}} >
                <DropDownListNew
                  currentData={[{id:1, item:"second"},{id:2, item:"minute"},{id:3, item:"hour"},{id:4, item:"day"},{id:5, item:"month"},{id:6, item:"year"}]}
                  minWidth={"30px"}
                  initialValue={currentConfigOption.estimated ? currentConfigOption.estimated.item : "min"}
                  id={"FrequenceDurationList"}
                  onDropDownItemClick={(itemSelected) => saveConfig("estimated", itemSelected)}
                  onlyLabel={false}
                />
              </div>
              </React.Fragment>
            }
        </div>
}

const updatePreviousState = (settingsData) => {
  settingsData.previousState =  JSON.parse(JSON.stringify(settingsData))
}

const onChangeOption = (optionText) => {
  
  if (isChanged) 
    setSetting({...settings, showLeave: true, next:optionText})
  else {
    var settingsData = JSON.parse(JSON.stringify(settings));
    settingsData = {...settings, option: optionText, next:undefined}
    updatePreviousState(settingsData)
    setSetting(settingsData)
    
    
  }
  
}

const getOptionPanel = (optionText, index) => {
  return <div id = {"Type" + optionText} key={"Type" +index} className="modal-list" onClick={() => onChangeOption(optionText)} >
          <div style={{marginRight: "20px", userSelect:"none",  borderBottom: optionText == settings.option ? "2px Solid dodgerblue" : "none"}}>
            {optionText}
          </div> 
        </div>
}

/*
const getOptionRadio = (optionText, index, isMultipleChoice) => {
  return <div key={index} className="modal-list">
          {isMultipleChoice && <div style={{ paddingTop: "2px"}}>
            <RadioIcon checked={isChecked(optionText)}
            click={() => onChangeOption(optionText)} />
          </div>}
          <div style={{marginRight: "20px"}}>
            {optionText}
          </div> 
        </div>
}*/

const setCurrentOption = (optionValue) => {
  var settingsData = JSON.parse(JSON.stringify(settings));
  
  if (!getCurrentOption(settingsData)[optionValue]) getCurrentOption(settingsData)[optionValue] = {details:[]}
      
    
  getCurrentOption(settingsData).option =optionValue
  
  setSetting(settingsData)
  if (optionValue == actions.event.api || optionValue == actions.decision.preConditions || optionValue == actions.decision.postConditions) toggle()
}

const onSetCurrentOption = (optionText) => {
  if (optionText != actions.task.form) {

    const previousOption = getCurrentOption().option
    if (previousOption == actions.task.form &&  isChanged) {
      setSetting({...settings, showLeave: true, next:optionText})
      return
    }
  }



  
  setCurrentOption(optionText)
}


const getOptionParams = (optionText, index) => {
  return <div id = {"Option" +optionText} key={"Option" +index} className="modal-list" onClick={() => onSetCurrentOption(optionText)} >
          <div style={{marginRight: "20px", userSelect:"none",  borderBottom: optionText == getCurrentOption().option ? "2px Solid dodgerblue" : "none"}}>
            {optionText}
          </div> 
        </div>
}

const isDecisionSubOption  = (optionTocheck) => {
  return optionTocheck == actions.decision.preConditions 
  || optionTocheck == actions.decision.postConditions
}

const isDecisionActif  = (optionTocheck = settings.option) => {
  return optionTocheck == actions.option.decision 
}

const isEventSubOption  = (optionTocheck) => {
  return optionTocheck == actions.event.email 
  || optionTocheck == actions.event.api
}

const isEventActif  = (optionTocheck = settings.option) => {
  return optionTocheck == actions.option.event 
}

const isTaskSubOption  = (optionTocheck) => {
  return optionTocheck == actions.task.policy 
      || optionTocheck == actions.task.alert
      || optionTocheck == actions.task.form

}


const isTaskActif  = (optionTocheck = settings.option) => {
  return optionTocheck == actions.option.task 
}


const onError = settings.errors.length > 0

const onSelect = (itemSelected) => {
  
  if (isChanged) 
    setSetting({...settings, showLeave: true, next:undefined})
  else {
    var settingsData = JSON.parse(JSON.stringify(settings));
    settingsData[settings.option.toLocaleLowerCase()].id = itemSelected.id
    
    updatePreviousState(settingsData)
    setSetting(settingsData)
  }
}

const getDesisionsLists = () => {
  const currentProcess = globalState.state.step.decisions.filter(process => process.id == settings.processId)[0]
  
  const currentDecision = currentProcess && currentProcess.childs.filter(step => step.id == settings.stepGlobalId)[0]
 
  return currentDecision ? currentDecision.childs.map(decision => { return {id:decision.id , item:decision.item } }) : []
}

return <React.Fragment>
          
            <div style ={{ padding:"10px 0 10px 20px", marginTop:"30px", backgroundColor: "white"}}>
              <div style ={{ display:"flex"}}>    
               
                {getTitle() }

                {!onError && 
                  <div style ={{  marginLeft:"10px", marginTop:"-5px"}}> 
                    <DropDownListNew
                      currentData={currentProcessSteps}
                      minWidth={"30px"}
                      initialValue={currentProcessSteps.filter(step => step.smallId == settings.stepId)[0].item}
                      id={"StepsList"}
                      onDropDownItemClick={(itemSelected) => onSelectStep(itemSelected)}
                      onlyLabel={false}
                    />
                  </div>  

                }
              </div>  
              <div>
                {<div className="modal-line">
                  {currentSetting.options.map((item, index) => getOptionPanel(item, index))}
                  {getSeparator()}
                  <div onClick ={() => !onError && fireEventOnSaveValue()} style={{paddingTop: "6px", userSelect:"none", marginRight:"5px", width:"20px"}}>
                    { settings.loading ? 
                      <div style ={{ marginTop:"-2px"}}><SpinnerIcon /> </div>: 
                      <SaveCommand actif = { isChanged} height="15px" /> }
                  </div> 
                  <div style={{paddingTop: "2px", userSelect:"none", marginRight:"10px"
                  , color : isChanged ? "black" : "rgb(223, 221, 221)" }}>
                    <span>Save</span> 
                  </div>
                  <div id = "InformationDiscardCommand" onClick ={(e) => setSetting({...settings, showDiscard:true})} style={{paddingTop: "6px", userSelect:"none", marginRight:"5px", width:"20px"}}>
                    { <DiscardCommand actif = { isChanged} height="15px" /> }
                  </div> 
                  <div style={{paddingTop: "2px", userSelect:"none", marginRight:"10px"
                  , color : isChanged ? "black" : "rgb(223, 221, 221)" }}>
                    <span>Discard</span> 
                  </div>
                </div>}
                {getOptionForm(settings.option)}
              </div>
              
              
            </div>
            {settings.showDiscard && <SimpleDialog changeModeRequired ={false} 
              onClickValid ={(e) => onDiscard(e)} onClose = {() => setSetting({...settings, showDiscard:false})}  
              value = "Are you sure ?"
              isLabel = {true}
              parentId = "InformationDiscardCommand" type = "field" operation = "DISCARD"/>}
            {settings.showLeave && <SimpleDialog changeModeRequired ={false} onClickValid ={(e) => onLeave(e)} 
              onClose = {() => setSetting({...settings, showLeave:false})}  
              value = "Do you want to leave ?"
              isLabel = {true}
              parentId = "InformationDiscardCommand" type = "field" operation = "LEAVE"/>}
            {!settings.loaded && <CustomLoading />}
            {customAlert.isVisible && <CustomAlert width={"300px"} title={"Settings Step"} 
              text = {customAlert.text} hide = {() => setCustomAlert({...customAlert, isVisible:false})}/>}
            {isShowing && <SimpleModal 
                columnsNames = {["name"]} 
                //columnsNames = {allColumns.filter(item=> item.id != globalState.state.formData.currentTool[0].id).map(name => name.item.toLowerCase())} 
                data = {{return:{type:"List", data:getDesisionsLists(), isVisible:!isDecisionPreConditionsActif()}}}
                formData = {globalState.state.formData} 
                previousForms = {globalState.state.previousForms}
                isShowing={isShowing} settings={getCurrentSettings()} //isShowing={isShowing} settings={currentSetting}
                onValidChange={(item) => fireEventOnSaveValue("onBlur", item)} 
                hide={() => {toggle()}} /> //hide={() => {toggle() ; changeMode(false)}} />
              }
        </React.Fragment>
  }
  
/* {!settings.loaded && <CustomLoading />}
  <div className="modal-line-left">
                <div onClick={props.hide} >
                  <input style ={{ border: "1px solid lightGray", backgroundColor: "white", fontSize:"12px", color : "lightGray"
                  , height: "25px", padding: "0px", width: "100px", }} type="button" className="button" value="Cancel"/>
                </div>
                <div onClick ={() => !onError && fireEventOnSaveValue()}>
                  <input style ={{ backgroundColor: onError  ? "lightGray" : "#008dff",  fontSize:"12px"
                  , height: "25px", padding: "0px", width: "100px", }} 
                  type="button" className="button" value="Save"/>
                </div>
              </div>
*/

